import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from '@deporvillage/utils-library-component';
import Picture from '@deporvillage/picture-component';

import styles from './AutocompleteList.module.scss';

const AutocompleteListClick = {
    Brand: 'brand',
    Category: 'category',
    All: 'all',
    Close: 'close',
    Item: 'item',
};

const BrandList = ({ brands, onClick }) => (
    <div className={styles['brand-list-component']}>
        <div className={styles['title']}>
            <I18n>header.search.autocomplete.brands</I18n>
            <div className={styles['brand-list-item-wrapper']}>
                {brands.map((b, idx) => (
                    <span key={b.name} className={styles['brand-list-item']}>
                        <a data-testid={`brand-item-${idx}`} href={b.url} title={b.name} onClick={onClick}><Picture src={`/brand/logo/bw/${b.image}`}
                            name={b.name} width={60} height={60} lazy /></a>
                    </span>
                ))}
            </div>
        </div>
    </div>
);

BrandList.propTypes = {
    brands: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            image: PropTypes.string,
            url: PropTypes.string,
        })
    ),
    onClick: PropTypes.func,
};

const CategoryList = ({ categories, onClick }) => (
    <div className={styles['category-list-component']}>
        <p className={styles['title']}>
            <I18n>header.search.autocomplete.categories</I18n>
        </p>
        <p className={styles['categories']}>
            {categories.map((c, idx) => (
                <span key={c.name} className={styles['category-list-item']}>
                    <a data-testid={`category-item-${idx}`} href={c.url} title={c.name} onClick={onClick} >{c.name}</a>
                </span>
            ))}
        </p>
    </div>
);

CategoryList.propTypes = {
    categories: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            url: PropTypes.string,
        })
    ),
    onClick: PropTypes.func,
};

const ListItem = ({ item, onClick }) => (
    <a className={styles['list-item-component']} href={item.url} onClick={onClick}>
        <div className={styles['list-item-img']}>
            <Picture src={`product/${item.gallery.images[item.gallery.default]}`}
                height={75} width={75} name={item.title} />
        </div>
        <span>{item.title}</span>
    </a>
);
ListItem.propTypes = {
    item: PropTypes.object,
    onClick: PropTypes.func,
};

const AutocompleteList = ({ query, count, items, categories, brands, onClick, onSubmit, onClose }) => {
    const handleClickBrand = () => onClick && onClick(AutocompleteListClick.Brand);
    const handleClickCategory = () => onClick && onClick(AutocompleteListClick.Category);
    const handleClickButton = (ev) => onSubmit && onSubmit(ev, AutocompleteListClick.All);
    const handleClickClose = () => onClose && onClose(AutocompleteListClick.Close);

    return (
        <div className={styles['autocomplete-list-component']} data-testid={'autocomplete-collection'}>
            <div className={styles['autocomplete-list-title']}>
                <I18n args={{ query }}>header.search.autocomplete.title</I18n>
                <span data-testid='icon-close' className={'icon icon-close'} onClick={handleClickClose} />
            </div>
            <div className={`${styles[`autocomplete-list-items`]} ${categories && categories.length ? styles['has-categories'] : ''}`}>
                {brands && brands.length ? <BrandList brands={brands} onClick={handleClickBrand} /> : null}
                {categories && categories.length ? <CategoryList categories={categories} onClick={handleClickCategory} /> : null}
                {items.map((i) => (<ListItem key={i.id} item={i} onClick={() => onClick && onClick(AutocompleteListClick.Item, i)} />))}
            </div>
            <div className={styles['autocomplete-list-action']}>
                <button onClick={handleClickButton} className={styles['autocomplete-button']}>
                    <I18n args={{ total: count }}>header.search.autocomplete.show</I18n>
                </button>
            </div>
        </div>
    );
};
AutocompleteList.propTypes = {
    query: PropTypes.string,
    count: PropTypes.number,
    items: PropTypes.array,
    categories: PropTypes.array,
    brands: PropTypes.array,
    onClick: PropTypes.func,
    onSubmit: PropTypes.func,
    onClose: PropTypes.func,
};

export default AutocompleteList;
export { AutocompleteListClick };
